export enum LoyalityPointsDirection {
  Earned = 1,
  Redeemed,
  PendingRedeemed
}
